import PackageRulesTable from "./package-rules-table";


export default PackageRulesTable;
